import React from "react";

/**
 * Ambient hero backdrop: a fine dot grid that fades out toward the edges, plus
 * two very soft amber washes. Deliberately low-contrast — it should register
 * as texture, never as an object.
 */
const AnimatedBackground = () => (
    <div
        aria-hidden="true"
        className="pointer-events-none absolute inset-0 overflow-hidden"
    >
        <div
            className="absolute inset-0 opacity-[0.35]"
            style={{
                backgroundImage:
                    "radial-gradient(rgba(255,255,255,0.12) 1px, transparent 1px)",
                backgroundSize: "26px 26px",
                maskImage:
                    "radial-gradient(ellipse 70% 60% at 30% 40%, #000 0%, transparent 75%)",
                WebkitMaskImage:
                    "radial-gradient(ellipse 70% 60% at 30% 40%, #000 0%, transparent 75%)",
            }}
        />
        <div
            className="absolute -left-32 top-[-10%] h-[520px] w-[520px] rounded-full
                       bg-accent/10 blur-[130px] animate-drift"
        />
        <div
            className="absolute right-[-8%] top-[35%] h-[420px] w-[420px] rounded-full
                       bg-white/[0.04] blur-[120px] animate-drift"
            style={{ animationDelay: "-8s" }}
        />
    </div>
);

export default AnimatedBackground;
